export default {
	"entry": {
		"mainOrderAndInfo": "主单+明细导入（只支持xls或xlsx）",
		"downloadMainOrderAndInfo": "下载主单+明细模板",
		"mainOrderNoInfo": "主单无明细导入（只支持xls或xlsx）",
		"downloadMainOrderNoInfo": "下载主单无明细模板",
		"orderImportSuccess": "运输订单导入成功",
		"void": "作废",
		"inputOrderTips": "请输入运输订单\\外部单",
		"orderStatus": "订单状态",
		"element": "元",
		"confirmOperationErrorPrompt": "确认操作错误提示",
		"batchModifiy": "批量修改",
		"modifiyTips": "需要一起修改的字段才填写，否则空着",
		"dispatchErrorTips": "直接调度操作错误提示",
		"dispatchSuccessTips": "调度成功",
		"currentDataNotUse": "当前数据状态不可操作",
		"reviewed": "已审核",
		"checkDataTips": "请勾选[已审核]状态的数据项!",
		"voidTips": "您将作废选中运输订单项, 是否继续?",
		"importOrder": "导入运输订单",
		"otherInfo": "其他信息",
		"custom": "自定义",
		"editingPageTips": "运输订单明细编辑页面",
		"orderDetaile": "下单明细货量",
		"attachmentTips": "随附单附件"
	},
	"entryCreate": {
		"againOrder": "再来一单",
		"directDispatch": "直接调度",
		"shipperTips": "请选择货主(必填)",
		"partnerNameTips": "请先选择货主",
		"orderQuantity": "下单货量",
		"doubleClickRestore": "双击恢复下单值",
		"temperatureControlNameTips": "请输入温控标准(必填)",
		"volumeTips": "请输入体积(必填)",
		"packingQtyTips": "请输入外包装数(必填)",
		"weightTips": "请输入重量(必填)",
		"goodsQtyTips": "请输入货品量",
		"goodsValueTips": "请输入声明货值(必填)",
		"goodsTypeTips": "请输入货品类型",
		"requirement": "要求",
		"deliverGoods": "发货",
		"receivingGoods": "收货",
		"pleaseSelectDate": "请选择日期(必选)",
		"pleaseSelectProvinceAndCityAndDistrict": "请选择省市县(必填)",
		"addressTips": "允许输入地址选择(必填)",
		"pickupCommentsTips": "请输入货品说明",
		"carrierProductNotEmpty": "承运产品/项目不能为空！",
		"latestReceivedDtTips": "最晚发货时间不能晚于最晚收货时间！",
		"latestDeliveryDtTips": "最晚收货时间不能早于最晚发货时间！",
		"cloneOrderTips": "已成功克隆运输订单数据，请根据具体情况调整运输订单参数。",
		"isInsuranceTips": "保价为'是'时，声明货值必须大于0",
		"dispatchFailedTips": "直接调度失败"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/order/order.js